import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { Theme } from '@mui/system';
import { ChangeEvent, useEffect, useState } from 'react';

type OptionsProps = {
    setOptions: (options: any) => void;
    theme: Theme;
};

export const PromoCampaignOptions = (props: OptionsProps) => {
    const { setOptions, theme } = props;
    const [countSubscribers, setCountSubscribers] = useState<boolean>(true);
    const [countTransitions, setCountTransitions] = useState<boolean>(true);
    const [suspiciousUsers, setSuspiciousUsers] = useState<boolean>(true);
    const [spendersCount, setSpendersCount] = useState<boolean>(false);
    const [totalEarnings, setTotalEarnings] = useState<boolean>(false);
    const [totalChargebacks, setTotalChargebacks] = useState<boolean>(false);
    const [subscribersGraph, setSubscribersGraph] = useState<boolean>(true);

    useEffect(() => {
        setOptions({
            ...(countSubscribers && { countSubscribers }),
            ...(countTransitions && { countTransitions }),
            ...(suspiciousUsers && { suspiciousUsers }),
            ...(spendersCount && { spendersCount }),
            ...(totalEarnings && { totalEarnings }),
            ...(totalChargebacks && { totalChargebacks }),
            ...(subscribersGraph && { subscribersGraph }),
        });
    }, [countSubscribers, countTransitions, setOptions, subscribersGraph, suspiciousUsers, totalChargebacks, totalEarnings, spendersCount]);

    return (
        <Grid container spacing={0} alignItems="center" flexGrow={1} sx={{ marginBottom: theme.spacing(2) }}>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={countSubscribers}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setCountSubscribers(checked);

                                if (!checked) {
                                    setSubscribersGraph(false);
                                }
                            }}
                        />
                    }
                    label="Total Subscribed"
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={countTransitions}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setCountTransitions(checked);
                            }}
                        />
                    }
                    label="Total Clicked"
                />
            </Grid>
            {/* <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={suspiciousUsers}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSuspiciousUsers(checked);
                            }}
                        />
                    }
                    label="Suspicious Users"
                />
            </Grid> */}
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={spendersCount}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSpendersCount(checked);
                            }}
                        />
                    }
                    label={
                        <span>
                            Total Spenders (<strong style={{ color: theme.palette.error.main }}>Careful!</strong>)
                        </span>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={totalEarnings}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setTotalEarnings(checked);
                            }}
                        />
                    }
                    label={
                        <span>
                            Total Earned (<strong style={{ color: theme.palette.error.main }}>Careful!</strong>)
                        </span>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={totalChargebacks}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setTotalChargebacks(checked);
                            }}
                        />
                    }
                    label={
                        <span>
                            Total Chargebacks (<strong style={{ color: theme.palette.error.main }}>Careful!</strong>)
                        </span>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            disabled={!countSubscribers}
                            checked={subscribersGraph}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSubscribersGraph(checked);
                            }}
                        />
                    }
                    label="Subscriptions Count and Clicks Count by Date Graph"
                />
            </Grid>
        </Grid>
    );
};

export const TrialOrPromoOptions = (props: OptionsProps) => {
    const { setOptions, theme } = props;
    const [claimsCount, setClaimsCount] = useState<boolean>(true);
    const [subscribeCounts, setSubscribeCounts] = useState<boolean>(true);
    const [suspiciousUsers, setSuspiciousUsers] = useState<boolean>(true);
    const [spendersCount, setSpendersCount] = useState<boolean>(false);
    const [totalEarnings, setTotalEarnings] = useState<boolean>(false);
    const [totalChargebacks, setTotalChargebacks] = useState<boolean>(false);
    const [subscribersGraph, setSubscribersGraph] = useState<boolean>(true);

    useEffect(() => {
        setOptions({
            ...(claimsCount && { claimsCount }),
            ...(subscribeCounts && { subscribeCounts }),
            ...(suspiciousUsers && { suspiciousUsers }),
            ...(spendersCount && { spendersCount }),
            ...(totalEarnings && { totalEarnings }),
            ...(totalChargebacks && { totalChargebacks }),
            ...(subscribersGraph && { subscribersGraph }),
        });
    }, [claimsCount, setOptions, subscribeCounts, subscribersGraph, suspiciousUsers, totalEarnings, totalChargebacks, spendersCount]);

    return (
        <Grid container spacing={0} alignItems="center" flexGrow={1} sx={{ marginBottom: theme.spacing(2) }}>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={claimsCount}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setClaimsCount(checked);

                                if (!checked) {
                                    setSubscribersGraph(false);
                                }
                            }}
                        />
                    }
                    label="Total Claimed"
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={subscribeCounts}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSubscribeCounts(checked);
                            }}
                        />
                    }
                    label="Total Subscribed"
                />
            </Grid>
            {/* <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={suspiciousUsers}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSuspiciousUsers(checked);
                            }}
                        />
                    }
                    label="Suspicious Users"
                />
            </Grid> */}
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={spendersCount}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSpendersCount(checked);
                            }}
                        />
                    }
                    label={
                        <span>
                            Total Spenders (<strong style={{ color: theme.palette.error.main }}>Careful!</strong>)
                        </span>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={totalEarnings}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setTotalEarnings(checked);
                            }}
                        />
                    }
                    label={
                        <span>
                            Total Earned (<strong style={{ color: theme.palette.error.main }}>Careful!</strong>)
                        </span>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            checked={totalChargebacks}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setTotalChargebacks(checked);
                            }}
                        />
                    }
                    label={
                        <span>
                            Total Chargebacks (<strong style={{ color: theme.palette.error.main }}>Careful!</strong>)
                        </span>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="medium"
                            disabled={!claimsCount}
                            checked={subscribersGraph}
                            onChange={(e: ChangeEvent, checked: boolean) => {
                                setSubscribersGraph(checked);
                            }}
                        />
                    }
                    label="Claims Count and Subscriptions Count by Date Graph"
                />
            </Grid>
        </Grid>
    );
};
